import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Shared parts of SupportSlice — plan §5.2. Mobile is a strict SUBSET: identical state
 * (8 fields, same defaults) and all 10 of its reducers are identical to web's, 0 divergent.
 * Web adds `updateSupportSlice` and the (empty-bodied) logout `extraReducers`.
 *
 * ⚠️ `action` must be `PayloadAction<any>`, never `any` — see the ledger. Reducers the apps
 * wrote with no `action` param (`getQueries`, `getQueriesLimit`, `getZohoUser`) keep that
 * shape: RTK generates no-payload creators for them today.
 *
 * Preserved verbatim, both odd and both intentional to keep:
 * - `getQueriesSuccess` / `getQueriesByTicketIdSuccess` sequence their two assignments with
 *   the COMMA OPERATOR. Collapsing that would drop the second assignment.
 * - `submitQuerySuccess` GUARDS on `payload.ticketId` but STORES `payload.ticketNumber`.
 *   Deliberately not "fixed" — the uplift changes no behaviour.
 */
export interface SharedSupportState {
    ticketData: any
    myQueries: any
    dataFetching: boolean
    querySubmitted: boolean
    isSuccessResponse: boolean
    createdTicketId: string
    queriesCount: number
    zohoUser: any
  }

export const sharedInitialState: SharedSupportState = {
    ticketData: {},
    myQueries:{},
    dataFetching: false,
    querySubmitted: false,
    isSuccessResponse : true,
    createdTicketId: "XXXXXXXXXXX",
    queriesCount: 0,
    zohoUser: {}
  };

/** Identical in both apps — every mobile reducer is here. */
export const sharedReducers = {
      getQueries : (state: SharedSupportState) =>{
        state.dataFetching = true;
      },
      getQueriesSuccess : (state: SharedSupportState, action: PayloadAction<any>) =>{
        state.myQueries = action.payload,
        state.dataFetching = false;
      },
      getQueriesByTicketId : (state: SharedSupportState, action: PayloadAction<any>) =>{
        state.dataFetching = true;
      },
      getQueriesByTicketIdSuccess : (state: SharedSupportState, action: PayloadAction<any>) =>{
        state.ticketData = action.payload,
        state.dataFetching = false;
      },
      submitQuery : (state: SharedSupportState, action: PayloadAction<any>) =>{
        state.querySubmitted = false;
        state.isSuccessResponse = false;
      },
      submitQuerySuccess: (state: SharedSupportState, action: PayloadAction<any>) =>{

        if (action?.payload?.ticketId){
            state.isSuccessResponse = true;
            state.createdTicketId = action?.payload?.ticketNumber;
        }
        state.querySubmitted = true;

      },
      getQueriesLimit: (state: SharedSupportState) => {
      },
      getQueriesLimitSuccess: (state: SharedSupportState, action: PayloadAction<any>) => {
        state.queriesCount =  action?.payload;
      },
      getZohoUser: (state: SharedSupportState) => {
      },
      getZohoUserSuccess: (state: SharedSupportState, action: PayloadAction<any>) => {
        state.zohoUser =  action?.payload;
      },
};
